"use strict";Object.defineProperty(exports, "__esModule", {value: true});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _definitions = require('./definitions');

exports. default = {
  mixins: [_definitions.vueFieldLabelMixin]
};

;(function(options){
  var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      class: _vm.className,
      attrs: { for: _vm.htmlFor },
      on: { click: _vm.onClick }
    },
    [
      _vm.collapsible
        ? _c(
            "button",
            {
              class:
                "ds-fieldLabel-collapseBtn " + (_vm.collapseStateClass || ""),
              attrs: { title: _vm.collapsed ? "展开" : "收起" }
            },
            [_vm._v("\n    " + _vm._s(_vm.collapsed ? "+" : "-") + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.text && _vm.schema.description
        ? _c(
            "abbr",
            {
              staticClass: "ds-fieldLabel-text",
              attrs: { title: _vm.schema.description }
            },
            [_vm._v(_vm._s(_vm.text))]
          )
        : _vm.text
        ? _c("span", { staticClass: "ds-fieldLabel-text" }, [
            _vm._v(_vm._s(_vm.text))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


  options.render = render
  options.staticRenderFns = staticRenderFns
  options._compiled = true
})(exports.default);
